module.exports = __webpack_public_path__ + "img/profile-top-dark.d1630a1.png";